import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { command, createStore } from 'ccstate'
import { StoreProvider } from 'ccstate-react'
import { initAuthStates$ } from '../frontend/authStates.ts'
import CurrentPage from './CurrentPage.tsx'
import { initRoutes$ } from '../frontend/router/navigate.ts'
import { setRootSignal$ } from '../ccstatex/rootSignal.ts'
import * as defaultTheme from './themes/defaultTheme.tsx'
import { setupFakeBackend } from '../frontend/setupFakeBackend.ts'
import * as Sentry from '@sentry/react'

defaultTheme.registerRoutes()
const store = createStore()

if (process.env.VITE_USE_FAKE_BACKEND === 'true') {
  store.set(setupFakeBackend)
}

const bootstrap$ = command(async ({set}) => {
  const rootController = new AbortController()
  set(setRootSignal$, rootController.signal)
  set(initAuthStates$)
  const itemId = 100
  const userId = 123
  Sentry.logger.info(
    Sentry.logger.fmt`Adding item ${itemId} for user ${userId}`,
  );
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <StoreProvider value={store}>
        <CurrentPage />
      </StoreProvider>
    </StrictMode>,
  )
  await set(initRoutes$, rootController.signal)
})
store.set(bootstrap$)
